// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-detail/components/edit-inventory/diagnosis-select/diagnosis-select.less
// module id = 3480
// module chunks = 0